export default "__VITE_ASSET__1G_sK2nw__"